import { Button, Input } from 'reactstrap';
import styled from 'styled-components';

export const Container = styled.div`
   font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
   background: #f5f5f5;
   min-height: 100vh;
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 20px;
`;
Container.displayName = 'Container';

export const Card = styled.div`
   background: white;
   border-radius: 16px;
   padding: 40px;
   max-width: 500px;
   width: 100%;
   box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
`;
Card.displayName = 'Card';

export const Title = styled.h1`
   font-size: 28px;
   font-weight: 700;
   color: #454545;
   margin-bottom: 4px;
   line-height: 1.2;
`;
Title.displayName = 'Title';

export const SubTitle = styled.h1`
   font-size: 16px;
   font-weight: 500;
   color: #545454;
   margin-bottom: 32px;
   /* line-height: 1.2; */
`;
SubTitle.displayName = 'SubTitle';

export const Brand = styled.span`
   color: #333;
`;
Brand.displayName = 'Brand';

export const Section = styled.div`
   margin-bottom: ${(props) => (props.$noBottomMargin !== undefined ? '0rem' : '2rem')};

   &:last-child {
      margin-bottom: 0;
   }
`;
Section.displayName = 'Section';

export const SectionTitle = styled.div`
   font-size: 17px;
   font-weight: 500;
   color: #525252;
   margin-bottom: 16px;
`;
SectionTitle.displayName = 'SectionTitle';

export const AddEmailContainer = styled.div`
   display: flex;
   gap: 12px;
   margin-bottom: 8px;

   @media (max-width: 480px) {
      flex-direction: column;
   }
`;
AddEmailContainer.displayName = 'AddEmailContainer';

export const StyledInput = styled(Input)`
   flex: 1;
   padding: 14px 16px !important;
   border: 2px solid #e2e8f0 !important;
   border-radius: 12px !important;
   font-size: 16px;
   transition: all 0.2s ease;
   background: white;
   height: 100%;

   &:focus {
      outline: none !important;
      border-color: #667eea !important;
      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1) !important;
   }
`;
StyledInput.displayName = 'StyledInput';

export const AddButton = styled(Button)`
   border: none !important;
   padding: 14px 24px !important;
   border-radius: 8px !important;
   font-size: 16px;
   font-weight: 600;
   white-space: nowrap;
   transition: all 0.2s ease;
   opacity: ${(props) => (props.$opacity !== undefined ? props.$opacity : 1)};
   cursor: ${(props) => (props.$cursor !== undefined ? `${props.$cursor} !important` : 'pointer  !important')};

   &:hover {
      background: #059bd1 !important;
   }

   @media (max-width: 480px) {
      padding: 16px !important;
   }
`;
AddButton.displayName = 'AddButton';

export const EmailList = styled.div`
   min-height: 60px;
   display: flex;
   flex-direction: column;
   gap: 12px;
`;
EmailList.displayName = 'EmailList';

export const EmailItem = styled.div`
   background: white;
   padding: 12px 16px;
   border: 1px solid #e2e8f0;
   border-radius: 8px;
   display: flex;
   justify-content: space-between;
   align-items: center;
   animation: slideIn 0.3s ease;

   @keyframes slideIn {
      from {
         opacity: 0;
         transform: translateY(-10px);
      }
      to {
         opacity: 1;
         transform: translateY(0);
      }
   }
`;
EmailItem.displayName = 'EmailItem';

export const EmailAddress = styled.span`
   font-size: 15px;
   color: #3a3f47;
   font-weight: 500;
`;
EmailAddress.displayName = 'EmailAddress';

export const RemoveButton = styled(Button)`
   background: #f4a261 !important;
   border: none !important;
   width: 28px !important;
   height: 28px !important;
   border-radius: 4px !important;
   font-size: 16px;
   padding: 0 !important;
   display: flex;
   align-items: center;
   justify-content: center;
   transition: all 0.2s ease;

   &:hover {
      background: #ff8c39 !important;
   }
`;
RemoveButton.displayName = 'RemoveButton';

export const EmptyState = styled.div`
   text-align: center;
   color: #a0aec0;
   font-style: italic;
   padding: 20px;
`;
EmptyState.displayName = 'EmptyState';

export const UnsubscribeButton = styled(Button)`
   background: #f4a261 !important;
   border: none !important;
   padding: 16px 32px !important;
   border-radius: 8px !important;
   font-size: 16px;
   font-weight: 600;
   width: 100%;
   transition: all 0.2s ease;

   &:hover {
      background: #ff8c39 !important;
   }
`;
UnsubscribeButton.displayName = 'UnsubscribeButton';

export const Tip = styled.div`
   background: #e3f2fd;
   border-radius: 8px;
   padding: 16px;
   margin-top: 24px;
   border-left: 4px solid #5eb3f5;
`;
Tip.displayName = 'Tip';

export const TipTitle = styled.div`
   font-weight: 600;
   color: #1976d2;
   margin-bottom: 8px;
`;
TipTitle.displayName = 'TipTitle';

export const TipContent = styled.div`
   color: #1565c0;
   line-height: 1.5;
   font-size: 14px;
`;
TipContent.displayName = 'TipContent';

export const LogoutButton = styled(Button)`
   background: #5d626a !important;
   border: none !important;
   padding: 8px 16px !important;
   border-radius: 6px !important;
   font-size: 14px;
   font-weight: 400;
   color: white !important;
   transition: all 0.2s ease;
   margin: 20px auto 0 auto !important;
   display: block !important;
   opacity: 0.7;

   &:hover {
      background: #6b7280 !important;
      opacity: 1;
   }
`;
LogoutButton.displayName = 'LogoutButton';
